
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import React from 'react';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import AirMonitoringSection from './components/AirMonitoringSection';
import NoiseMonitoringSection from './components/NoiseMonitoringSection';
import SilicaMonitoringSection from './components/SilicaMonitoringSection';
import WeldingFumesSection from './components/WeldingFumesSection';
import PaintsCoatingsSection from './components/PaintsCoatingsSection';
import ComprehensiveApproachSection from './components/ComprehensiveApproachSection';
import IndustriesSection from './components/IndustriesSection';
import ContactFormSection from './components/ContactFormSection';

const IndustrialHygienePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Industrial Hygiene Services - HP Inc Consulting Services | Environmental Monitoring"
        description="Professional industrial hygiene services including air quality monitoring, noise assessment, silica monitoring, and workplace environmental testing. Expert industrial hygienists serving New York and Northeast."
        keywords="industrial hygiene, air quality monitoring, noise monitoring, silica monitoring, workplace environmental testing, occupational health, exposure assessment, industrial hygienist, environmental monitoring, workplace safety assessment"
        canonical="https://hpincconsultant.com/industrial-hygiene"
        ogTitle="Industrial Hygiene Services - Professional Environmental Monitoring"
        ogDescription="Expert industrial hygiene and environmental monitoring services for workplace safety and health compliance."
        ogUrl="https://hpincconsultant.com/industrial-hygiene"
      />
      <Header />
      <main>
        <HeroSection />
        <IntroSection />
        <AirMonitoringSection />
        <NoiseMonitoringSection />
        <SilicaMonitoringSection />
        <WeldingFumesSection />
        <PaintsCoatingsSection />
        <ComprehensiveApproachSection />
        <IndustriesSection />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
};

export default IndustrialHygienePage;
